import React from "react";
import { legalLinks, offer } from "../data/offer";
export function SiteFooter() {
  return <footer className="bg-ink text-cream" data-id="element-162" data-mp="3r7pwlv53ab3z">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-5 py-12 md:flex-row md:items-start md:justify-between" data-id="element-163" data-mp="3r91ains90z8t">
        <div data-id="element-164" data-mp="3mf6huuuo19xl">
          <p className="font-display text-xl font-semibold" data-id="element-165" data-mp="3hig268mrwgcp">{offer.brand}</p>
          <p className="mt-3 text-sm text-cream/75" data-id="element-166" data-mp="3hgddpt19qva3">
            Support :{" "}
            {offer.supportEmail ? <a href={`mailto:${offer.supportEmail}`} className="underline underline-offset-4 hover:text-cream" data-id="element-167" data-mp="38hrppid12o1x">
                {offer.supportEmail}
              </a> : <span data-id="element-168" data-mp="33ki1u75aekg7">adresse de contact communiquée prochainement</span>}
          </p>
        </div>
        <nav aria-label="Informations légales" data-id="element-169" data-mp="11rbopyd25ka1">
          <ul className="grid gap-3 text-sm sm:grid-cols-2 sm:gap-x-10" data-id="element-170" data-mp="11q0og8itmuno">
            {legalLinks.map(link => <li key={link.label} data-id="element-171" data-mp="wt0g1qyi1fte">
                {link.href ? <a href={link.href} className="text-cream/85 underline-offset-4 hover:text-cream hover:underline" data-id="element-172" data-mp="15ptvys4krqvw">
                    {link.label}
                  </a> : <span className="text-cream/60" data-id="element-173" data-mp="vth6k6g2bz6y">{link.label}</span>}
              </li>)}
          </ul>
        </nav>
      </div>
      <div className="border-t border-cream/10 px-5 py-5 text-center text-xs text-cream/60" data-id="element-174" data-mp="10tllhs1bolv2">
        © {new Date().getFullYear()} {offer.brand}. Tous droits réservés.
      </div>
    </footer>;
}